import request from '../../utils/requests'
/** * Tag: GoodsOrder */
const baseUrl ="/api/GoodsOrder";

/** * 根据规格查询库存 * @param {*} body * { *    BranchId Desc: Required:false *    GoodsId Desc: Required:false *    GoodsSpecId1 Desc: Required:false *    GoodsSpecId2 Desc: Required:false * } */async function _getStockByGoodsSpec(body) {  return request(baseUrl+'/getStockByGoodsSpec',{    method: 'POST',    body: body,  });
}

export default{  _getStockByGoodsSpec}



// WEBPACK FOOTER //
// ./src/services/goodsOrder.js